import React from 'react';
import styled from 'styled-components';
import { CartItemHeadings, CartItemName, CartItemSubHeading } from './CommonStyles';

interface ICartItemTitle {
  title: string;
  subheading: string | string[];
}

const CartItemKitItem = styled(CartItemSubHeading)`
  display: list-item;
  margin-left: 15px;
`;

const CartItemTitle = ({ title, subheading }: ICartItemTitle): JSX.Element => (
  <CartItemHeadings className="cart-item-headings">
    <CartItemName
      className="cart-item-name"
      data-test-id="dp_product_name"
      dangerouslySetInnerHTML={{ __html: title }} // title string can be HTML
    />
    {Array.isArray(subheading)
      ? subheading.map(item => (
        <CartItemKitItem
          key={item}
          className="cart-item-child cart-item-subproduct-name"
          dangerouslySetInnerHTML={{ __html: item }} // item string can be HTML
        />
      )) : (
        <CartItemSubHeading
          className="cart-item-child cart-item-subproduct-name"
          dangerouslySetInnerHTML={{ __html: subheading }} // subheading string can be HTML
        />
      )}
  </CartItemHeadings>
);

export default CartItemTitle;
